<section class="app-table-container" animated>
    <mat-table [dataSource]="dataSource"
               [class.mobile-layout]="mobileMode$ | async"
               class="request-form-submission-approvals-table"
               appTable
               matSort
               matSortActive="name"
               matSortDirection="desc"
               matSortDisableClear="true"
               multiTemplateDataRows>
        <ng-container matColumnDef="mobile">
            <mat-header-cell *matHeaderCellDef>{{ columnMap[0].title }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
                {{ row.membership?.profile.givenNames }} {{ row.membership?.profile.familyName }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[1].title }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
                {{ row.membership?.profile.givenNames }} {{ row.membership?.profile.familyName }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef>{{ columnMap[2].title }}</mat-header-cell>
            <mat-cell *matCellDef="let row" [emptyCell]="!row.approves && !row.denies">
                <mat-icon *ngIf="row.approves && !row.denies" class="success-color" [svgIcon]="'v2:fi-br-check-circle'"></mat-icon>
                <mat-icon *ngIf="!row.approves && row.denies" class="error-color">do_not_disturb</mat-icon>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[3].title }}</mat-header-cell>
            <mat-cell *matCellDef="let row" [emptyCell]="!row.approves && !row.denies">
                {{ row.createdAt | legfiDate:'MM/DD/YYYY' }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef justifyRightCell><span class="no-wrap">{{ columnMap[4].title }}</span></mat-header-cell>
            <mat-cell *matCellDef="let row" [emptyCell]="row.approves || row.denies" justifyRightCell>
                <button mat-flat-button linkButton disableRipple preventClick
                        [disabled]="emailingApproverId !== -1"
                        (click)="notifyApprover(row.formApproverId)">
                    {{ 'Send Reminder' }}
                </button>
            </mat-cell>
        </ng-container>

        <div *matNoDataRow>
            <app-loading-table-state
                [keys]="columnKeys$ | async"
                [headerRow]="tableHeaderRef">
            </app-loading-table-state>
        </div>

        <ng-container matColumnDef="workingProgressBar">
            <mat-cell *matCellDef="let row">
                <mat-progress-bar mode="query" color="primary" [class.active]="!isLoadingApprovals && emailingApproverId !== -1"></mat-progress-bar>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnKeys$ | async; sticky: true"
                        [headerRow]="true"
                        appTableRow>
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: ['workingProgressBar']; let isFirst = first"
                 [workingRow]="true"
                 [firstRow]="isFirst"
                 appTableRow>
        </mat-row>
        <mat-row *matRowDef="let row; columns: columnKeys$ | async"
                 animated
                 delayed="table"
                 [hasAnimation]="rowsAnimated"
                 appTableRow>
        </mat-row>
    </mat-table>
</section>
